module.exports = __webpack_public_path__ + "pic2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic2.jpg
// module id = 1522
// module chunks = 13